// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NmOx","title":"styles_title__3tBvk"};